<template>
  <el-table
    :data="glaNumbers"
    max-height="250"
    style="width: 100%"
    v-loading="loading"
    :default-sort="{prop: 'value', order: 'ascending'}"
  >
    <el-table-column
      prop="value"
      label="Érték"
    />
    <el-table-column
      prop="description"
      label="Megnevezés"
      show-overflow-tooltip
    />
    <el-table-column
      fixed="right"
      label=""
      width="120"
    >
      <template slot-scope="scope">
        <Actions :glaNumber="scope.row" />
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
  import Actions from './Actions'

  export default {

    components: {
      Actions
    },

    computed: {
      glaNumbers() {
        return this.$store.getters['glaNumber/glaNumbers'];
      },

      loading() {
        return this.$store.getters['glaNumber/loading'];
      }
    },

    async mounted() {
      await this.$store.dispatch('glaNumber/fetchAll');
    },
  }
</script>
